import { Component, inject, OnInit } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Component({
  selector: 'app-oicd-logout',
  imports: [],
  standalone: true,
  templateUrl: './oicd-logout.component.html',
  styleUrl: './oicd-logout.component.css'
})
export class OicdLogoutComponent implements OnInit {
  private readonly oidcSecurityService = inject(OidcSecurityService);
  ngOnInit(): void {
    console.log('OicdLogoutComponent');
    this.oidcSecurityService.logoffAndRevokeTokens().subscribe(res => 
      console.log('Client-Lieferantenserver: Logout und Token-Widerruf erfolgreich', res));
  
  }
}
